import { render, staticRenderFns } from "./ReturnStatusesForm.vue?vue&type=template&id=12e4b502&scoped=true&"
import script from "./ReturnStatusesForm.vue?vue&type=script&lang=js&"
export * from "./ReturnStatusesForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnStatusesForm.vue?vue&type=style&index=0&id=12e4b502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4b502",
  null
  
)

export default component.exports